import {LINE_SEPARATOR} from '../clipboard-utils';

export function cardsToText(decklistCards) {
  return decklistCards.map(cardData => {
    const amount = cardData.amount ? cardData.amount : 1;
    if (cardData.custom) {
      return `${amount} ${cardData.card.name} [Custom]`
    }

    return `${amount} ${cardData.card.name}`;
  }).join(LINE_SEPARATOR);
}

export function cardsToTextFromDeckSection(section, decklistCards) {
  const filteredCards = decklistCards.filter(item => item.type === section);
  return cardsToText(filteredCards);
}

export function decklistToText(deck) {
  const cards = deck.cards || deck;
  const maindeck = deck && cardsToTextFromDeckSection('maindeck', cards);
  const sideboard = deck && cardsToTextFromDeckSection('sideboard', cards);

  return [maindeck, 'SIDEBOARD', sideboard].join(LINE_SEPARATOR);
}
